import { render, staticRenderFns } from "./SMSDetailModal.vue?vue&type=template&id=be636df4&scoped=true&"
import script from "./SMSDetailModal.vue?vue&type=script&lang=js&"
export * from "./SMSDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./SMSDetailModal.vue?vue&type=style&index=0&id=be636df4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be636df4",
  null
  
)

export default component.exports